import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOutlinedBellArchedRingingIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_12270_1445)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M10 5C10 4.46957 10.2107 3.96086 10.5858 3.58579C10.9609 3.21071 11.4696 3 12 3C12.5304 3 13.0391 3.21071 13.4142 3.58579C13.7893 3.96086 14 4.46957 14 5C15.1484 5.54303 16.1274 6.38833 16.8321 7.4453C17.5367 8.50227 17.9404 9.73107 18 11V14C18.0753 14.6217 18.2954 15.2171 18.6428 15.7381C18.9902 16.2592 19.4551 16.6914 20 17H4C4.54494 16.6914 5.00981 16.2592 5.35719 15.7381C5.70457 15.2171 5.92474 14.6217 6 14V11C6.05956 9.73107 6.4633 8.50227 7.16795 7.4453C7.8726 6.38833 8.85159 5.54303 10 5Z",
					stroke: "#333333",
					strokeWidth: 1.5,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9 17V18C9 18.7956 9.31607 19.5587 9.87868 20.1213C10.4413 20.6839 11.2044 21 12 21C12.7956 21 13.5587 20.6839 14.1213 20.1213C14.6839 19.5587 15 18.7956 15 18V17",
					stroke: "#333333",
					strokeWidth: 1.5,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M21.0001 6.727C20.3441 5.30025 19.3916 4.02969 18.2061 3",
					stroke: "#333333",
					strokeWidth: 1.5,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M3 6.727C3.65535 5.30044 4.60715 4.0299 5.792 3",
					stroke: "#333333",
					strokeWidth: 1.5,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_12270_1445",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgOutlinedBellArchedRingingIcon);
const Memo = memo(ForwardRef);
export default Memo;
